import {Module} from "vuex";
import {RootState} from "@/store/types";
import {customTemplate} from "@/store/custom/templates";
import {customStatistic} from "@/store/custom/statistic";

export const customModule: Module<any, RootState> = {
    modules: {
        customTemplate,
        customStatistic,
    }
}
